
<div class="column-pagination d-flex align-items-center">
    <span class="mr-2">Page {{ fieldPagination.current_page }} of {{ fieldPagination.total_pages }} |
        Columns {{ startColumn }}-{{ endColumn }} of {{ fieldPagination.total_count }}</span>
    <div class="d-flex" style="gap: 10px;">
        <!-- First Page Button -->
        <v-icon size="22" dense
            :style="{ color: canGoPrev ? '#007BFF' : '#BDBDBD', cursor: canGoPrev ? 'pointer' : 'default' }"
            @click="goToPage(1)">
            mdi-page-first
        </v-icon>

        <!-- Previous Button -->
        <v-icon size="22" dense
            :style="{ color: canGoPrev ? '#007BFF' : '#BDBDBD', cursor: canGoPrev ? 'pointer' : 'default' }"
            @click="goToPage(fieldPagination.current_page - 1)">
            mdi-chevron-left
        </v-icon>

        <!-- Next Button -->
        <v-icon size="22" dense
            :style="{ color: canGoNext ? '#007BFF' : '#BDBDBD', cursor: canGoNext ? 'pointer' : 'default' }"
            @click="goToPage(fieldPagination.current_page + 1)">
            mdi-chevron-right
        </v-icon>

        <!-- Last Page Button -->
        <v-icon size="22" dense
            :style="{ color: canGoNext ? '#007BFF' : '#BDBDBD', cursor: canGoNext ? 'pointer' : 'default' }"
            @click="goToPage(fieldPagination.total_pages)">
            mdi-page-last
        </v-icon>
    </div>
</div>
